export default __webpack_public_path__ + "static/media/rebrand-qkn-blurple-logo.5bda8867.svg";